<script lang="ts">
	import { onMount } from "svelte";
	import type { ContentType } from "@core/schema/ContentType.js";
	import type { ContentBlockComponentProps } from "./ContentBlockComponentProps.js";

	const _: ContentBlockComponentProps<ContentType.Lock> = $props();

	onMount(() => {
		throw new TypeError("This ContentType is not allowed on web.");
	});
</script>
